import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('issuer_disclaimer', '/issuer_disclaimers')
const actions = generator.generate()

export default actions
